import clsx from 'clsx';
import { Banknote, MessageSquare, Menu, Truck } from 'lucide-react';
import { navigate, useRoute } from '../lib/router';
import { db, metaGet, useLive } from '../lib/db';

/** Четири мишени, всяка над 70 px. Повече от четири не се уцелват с ръкавица. */
export function BottomNav() {
  const { path } = useRoute();
  const unread = useLive(
    async () => {
      const readAt = (await metaGet<string>('messages.readAt')) ?? '';
      const incoming = await db.messages.where('direction').equals('in').toArray();
      return incoming.filter((message) => message.sentAt > readAt).length;
    },
    [],
    0,
  );

  const items = [
    { to: '/', label: 'Днес', icon: Truck, active: path === '/' || path.startsWith('/stop') },
    {
      to: '/expense',
      /* По-дълъг от другите надписи — на два реда в по-дребен шрифт. */
      label: 'Непредвиден разход',
      icon: Banknote,
      active: path.startsWith('/expense'),
      compact: true,
    },
    {
      to: '/messages',
      label: 'Съобщения',
      icon: MessageSquare,
      active: path.startsWith('/messages'),
      badge: unread,
    },
    { to: '/more', label: 'Още', icon: Menu, active: path.startsWith('/more') },
  ];

  /**
   * Колоните са равни, но никоя не става по-тясна от надписа си: на тесен
   * телефон или с едър текст „Съобщения" и „Непредвиден" иначе излизат от
   * своята четвърт и застъпват съседа. Тогава място отстъпват „Днес" и „Още".
   */
  return (
    <nav className="safe-bottom sticky bottom-0 z-30 grid grid-cols-[repeat(4,1fr)] bg-brand text-white shadow-[0_-2px_0_0_var(--app-accent)]">
      {items.map((item) => (
        <button
          key={item.to}
          type="button"
          onClick={() => navigate(item.to)}
          aria-current={item.active ? 'page' : undefined}
          className={clsx(
            'relative flex flex-col items-center justify-center gap-1 px-0.5 py-2 text-sm font-semibold',
            item.active ? 'text-white' : 'text-white/65',
          )}
          style={{ minHeight: 72 }}
        >
          {/* Избраният раздел: зеленото „X" от логото зад иконата. */}
          <span
            className={clsx(
              'flex h-9 w-14 items-center justify-center rounded-full',
              item.active && 'bg-accent text-accent-ink',
            )}
          >
            <item.icon size={26} strokeWidth={item.active ? 2.6 : 2} />
          </span>
          <span className={clsx('text-center', item.compact && 'text-xs leading-tight')}>
            {item.label}
          </span>
          {item.badge && item.badge > 0 ? (
            <span className="absolute right-[18%] top-1 min-w-7 rounded-full bg-stop px-2 py-0.5 text-center text-sm font-bold text-white">
              {item.badge}
            </span>
          ) : null}
        </button>
      ))}
    </nav>
  );
}
